import stateList from "@/utils/us_states.js";

// VIB-1735: whether the order's `orderTagList` contains a given tag. Backend tags a Gut Zoomer
// order with "GZ" and a Gut Zoomer New York order with "GZ_NY".
export function checkWhetherOrderHasTag(orderTagList, tag){
    if(!Array.isArray(orderTagList)){
        return false;
    }
    const target = tag.trim().toLowerCase();
    return orderTagList.some(value => typeof value == 'string' && value.trim().toLowerCase() == target);
}

// VIB-1735: whether a state value (abbreviation like "NY" or full name like "New York")
// classifies as the New York jurisdiction. NY status is determined solely by patient address.
export function isNewYorkState(state){
    if(!state || typeof state != 'string'){
        return false;
    }
    return ['ny', 'new york'].includes(state.trim().toLowerCase());
}

// VIB-1735: map a state value to its full display name (e.g. "CA" -> "California") for the
// §4.2 popup copy. Falls back to the raw value when it can't be matched.
export function getFullStateName(state){
    if(!state || typeof state != 'string'){
        return state ?? '';
    }
    const trimmed = state.trim();
    const match = stateList.find(s =>
        s.abbreviation.toLowerCase() == trimmed.toLowerCase() || s.name.toLowerCase() == trimmed.toLowerCase()
    );
    return match ? match.name : trimmed;
}

export function checkWhetherHasGutZoomer(orderItems){
    // Check if the order items contain Gut Zoomer related tests.
    // param orderItems: Array of order items, the orderItems field in the response of /orderV2 or graphQL patientOrder
    // 06/04/2025: VIB-1117 new Gut Zoomer item_ids updated, NOTES: need to check both old ids and new ids
    // 02/04/2026: VIB-1588 new Gut Zoomer item_ids updated, NOTES: Gut Zoomer 5.0 and new menu release
    const gutZoomer_item_ids = {
        "test_mapping": {
            // ****** old logic of 06/04/2025 ******
            "186": 837,
            "187": 838,
            "188": 839,
            "61": 836,
            // ****** old logic of 06/04/2025 end ******
            // ****** new logic of 02/04/2026 ******
            '845': 845
            // ****** new logic of 02/04/2026 end ******
        },
        // "bundle_mapping": {
        //     // ****** old logic of 06/04/2025  ******
        //     "101492": 18004,
        //     "18210": 18001,
        //     "18267": 18002,
        //     "18336": 18003,
        //     // ****** old logic of 06/04/2025 end ******
        //     // ****** new logic of 02/04/2026 ******
        //     '1': 1, 
        //     '6': 6, 
        //     '18008': 18008, 
        //     '18009': 18009, 
        //     '18010': 18010, 
        //     '18011': 18011, 
        //     '18012': 18012, 
        //     '18013': 18013, 
        //     '18020': 18020, 
        //     '18021': 18021, 
        //     '18022': 18022
        //     // ****** new logic of 02/04/2026 end *****
        // }
    }
    // 1. item_type: "packagePriceId"; item_id: 61, 186, 187, 188 (old ones) -> add new ones which are values in the test_mapping
    const packagePriceId_gutZoomer_item_ids = Object.entries(gutZoomer_item_ids.test_mapping).flat().map(Number);
    // console.log("packagePriceId_gutZoomer_item_ids", packagePriceId_gutZoomer_item_ids);
    // // 2. item_type: "bundleId"; item_id: 18210, 18267, 18336, 101492 (old ones) -> add new ones which are values in the bundle_mapping
    // const bundleId_gutZoomer_item_ids = Object.entries(gutZoomer_item_ids.bundle_mapping).flat().map(Number);
    // 3. if x_choose_y_list != null (only possible when item_type == "bundleId"): 
    //    -> check whether x_choose_y_detail_list in the first element of x_choose_y_list has 'packagePriceId' (item_id: 61, 186, 187, 188)
    // NOTES: !! ensures you always get a boolean (true or false)
    let has_gutZoomer = !!orderItems?.some(item => {
        // console.log("order item", item);
        if(item.item_type == "packagePriceId" && packagePriceId_gutZoomer_item_ids.includes(item.item_id)){
            
            return true;
        }else if(item.item_type == "bundleId" && item.x_choose_y_List != null){
            return item.x_choose_y_List?.[0].x_choose_y_detail_list?.some(x_choose_y_detail => {
                // console.log("x_choose_y_detail 2", x_choose_y_detail);
                return x_choose_y_detail.item_type == "packagePriceId" && packagePriceId_gutZoomer_item_ids.includes(x_choose_y_detail.item_id);
            });
        }
        return false;
    });
    
    return has_gutZoomer;
}